// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"782":"d8e579e2","879":"236dc342"}[chunkId] + ".chunk.js";
};